import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: 'kodit-saldo-card',
  templateUrl: './saldo-card.component.html',
  styleUrls: ['./saldo-card.component.scss'],
})
export class SaldoCardComponent implements OnInit {
  @Input() topText: string;
  @Input() topText2?: string;
  @Input() topText3?: string;
  @Input() mainText: string;
  @Input() mainText2?: string;
  @Input() mainText3?: string;
  @Input() bottomText?: string;
  @Input() bottomText2?: string;
  @Input() bottomText3?: string;
  @Input() helperIcon?: string;
  @Input() mainTextClass: string = '';
  @Input() displayActionBtn = false;

  constructor() {}

  ngOnInit(): void {
  }
}
